import SectionHeader from "./reusable/SectionHeader"
import CurriculumCards from "./CurriculumCards"
import Button from "./reusable/Button"
import {useState} from 'react'


const Curriculum = () => {
  const [curriculum_view, setCurriculumView] = useState(6);
  const [button_text, setButtonText] = useState("View more")
  const viewMore = () => {
    if (curriculum_view === 6) {
      setButtonText("View less")
      setCurriculumView(20)
    } else {
      setButtonText("View more")
      setCurriculumView(6)
    }
  }
  return (
    <div id="curriculum" className="section_margin">
      <SectionHeader title="Our Training Curriculum" caption="You'll acquire knowledge that will clearly differentiate you from other assistants, thanks to our training curriculum" />
      <CurriculumCards curriculum_view={curriculum_view}/>
      <div className="flex justify-center mt-8">
      <div onClick={viewMore}>
        <Button text={button_text}/>
      </div>
      </div>
    </div>
  )
}

export default Curriculum